// Reserve space for the host's optional overlay without hiding or changing it.
// Watch only the overlay and direct body children; no work runs on pointer move.
export function connectHostingOverlayClearance(dock, onChange) {
  const doc=dock.ownerDocument,win=doc.defaultView;
  let badge=null,closed=false;
  const attributeObserver=typeof MutationObserver==='function'?new MutationObserver(update):null;
  const resizeObserver=typeof ResizeObserver==='function'?new ResizeObserver(update):null;
  function update(){
    if(closed)return;
    const next=doc.getElementById('nl-badge-frame');
    if(next!==badge){
      if(badge)resizeObserver?.unobserve(badge);
      attributeObserver?.disconnect();badge=next;
      if(badge){resizeObserver?.observe(badge);attributeObserver?.observe(badge,{attributes:true,attributeFilter:['style','hidden','class']});}
    }
    let bottom=0,overlayBottom=0;
    if(badge){
      const box=badge.getBoundingClientRect(),nav=dock.getBoundingClientRect(),style=win.getComputedStyle(badge),height=win.innerHeight;
      if(style.display!=='none'&&style.visibility!=='hidden'&&!badge.hidden&&box.width>0&&box.height>0&&box.top>height/2&&box.bottom<=height+8){
        overlayBottom=Math.ceil(height-box.top+8);
        if(nav.width>0&&box.left<nav.right+8&&box.right>nav.left-8)bottom=overlayBottom;
      }
    }
    const value=`${bottom}px`;
    if(dock.style.getPropertyValue('--tl-hosting-overlay-bottom')!==value||doc.documentElement.style.getPropertyValue('--tl-hosting-overlay-bottom')!==`${overlayBottom}px`){
      dock.style.setProperty('--tl-hosting-overlay-bottom',value);
      doc.documentElement.style.setProperty('--tl-hosting-overlay-bottom',`${overlayBottom}px`);
      doc.documentElement.classList.toggle('tl-host-overlay-present',overlayBottom>0);
      onChange?.();
    }
  }
  const bodyObserver=typeof MutationObserver==='function'?new MutationObserver(update):null;
  bodyObserver?.observe(doc.body,{childList:true});resizeObserver?.observe(dock);
  win.addEventListener('resize',update);win.visualViewport?.addEventListener('resize',update);update();
  return()=>{closed=true;bodyObserver?.disconnect();attributeObserver?.disconnect();resizeObserver?.disconnect();win.removeEventListener('resize',update);win.visualViewport?.removeEventListener('resize',update);dock.style.removeProperty('--tl-hosting-overlay-bottom');doc.documentElement.style.removeProperty('--tl-hosting-overlay-bottom');doc.documentElement.classList.remove('tl-host-overlay-present');};
}
